import { useState } from "react";
import { UserRound } from "lucide-react";

export default function CharacterImage({ src, alt, testId }) {
  const [failed, setFailed] = useState(false);
  return (
    <div className="relative aspect-[2/3] overflow-hidden rounded-2xl border border-[#D4AF37]/10 bg-[#2B3A4A]">
      {failed ? (
        <div
          className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center"
          style={{
            background:
              "linear-gradient(135deg, #1A1D24 0%, #2B3A4A 60%, rgba(212,175,55,0.15) 100%)",
          }}
          data-testid={testId}
        >
          <UserRound size={44} style={{ color: "#D4AF37", opacity: 0.55 }} className="mb-3" />
          <div className="overline">Portrait Coming Soon</div>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          onError={() => setFailed(true)}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
        />
      )}
    </div>
  );
}
